<template>
  <section class="bulk-mark-as-paid-wrapper">
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col md="12">
            <div class="d-flex align-items-center justify-content-between">
              <h2>{{ $t("cashiers.bulk-mark-as-paid-title") }}</h2>
              <b-button
                variant="outline-secondary"
                size="sm"
                @click="$router.back()"
              >
                <feather-icon icon="ArrowLeftIcon" class="mr-1" size="14" />
                {{ $t("cashiers.back-to-list") }}
              </b-button>
            </div>
          </b-col>
          <b-col cols="12" md="12"><br /></b-col>

          <b-col md="8" cols="12">
            <b-form-group
              :label="$t('cashiers.invoice-ids')"
              label-for="invoice-ids"
            >
              <b-form-textarea
                id="invoice-ids"
                v-model="invoiceIdsInput"
                rows="6"
                :placeholder="$t('cashiers.invoice-ids-placeholder')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.description')" label-for="note">
              <b-form-input id="note" v-model="note" />
            </b-form-group>
            <b-button
              :disabled="submitting || parsedIds.length === 0"
              variant="success"
              @click="submitBulk()"
            >
              {{ $t("cashiers.mark-as-paid") }} ({{ parsedIds.length }})
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormGroup,
  BFormTextarea,
  BFormInput,
  BButton,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "BulkMarkAsPaid",
  components: {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BButton,
  },
  data() {
    return {
      invoiceIdsInput: "",
      note: "",
      submitting: false,
    };
  },
  computed: {
    parsedIds() {
      if (!this.invoiceIdsInput) return [];
      return this.invoiceIdsInput
        .split(/[,\n\s]+/)
        .map((s) => s.trim())
        .filter(Boolean);
    },
  },
  methods: {
    async submitBulk() {
      if (this.parsedIds.length === 0) return;
      this.submitting = true;
      try {
        const form = { invoice_ids: this.parsedIds };
        if (this.note?.trim()) form.note = this.note.trim();
        await this.create({ path: "invoices/bulk-mark-as-paid", form });
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("common.success"),
            icon: "CheckIcon",
            variant: "success",
            text: this.$t("cashiers.bulk-paid-success"),
          },
        });
        this.invoiceIdsInput = "";
        this.note = "";
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("common.error"),
            icon: "AlertCircleIcon",
            variant: "danger",
            text:
              error.response?.data?.message ||
              this.$t("cashiers.bulk-paid-failed"),
          },
        });
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped></style>
